var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nodatamain"},[_c('img',{class:{full:_vm.full},attrs:{"src":require("@/assets/common/imgs/PCimg/nodata.png"),"alt":""}}),_vm._v(" "),_c('p',{staticClass:"msg"},[_vm._v(_vm._s(_vm.innerText))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6cac3722","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nodata.vue
// module id = null
// module chunks = 